// @flow

import { type Address } from './types';

export function getZipcode(address: Address): string {
  return address['zipcode'] || '';
}
